import React from 'react'
import About from './pages/About'
import Home from './pages/Home'
import Contact from './pages/Contact'
import { BrowserRouter as Router , Routes, Route } from 'react-router-dom'
import Footer from './components/Footer'
import Header from './components/Header'
//import Navbar from './components/Navbar'
import BookADemo from './pages/BookADemo'
import HabiTech from './pages/HabiTech'
import SchoolERP from './pages/SchoolERP'
import Career from './pages/CareerPage'
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (    
    <Router>
    <ScrollToTop />
    <Header/>
    {/* <Navbar/> */}
    {/*<Carousal/>
    <Facts/>*/}
    <Routes>
    <Route path='/' element={<Home/>}></Route>
    <Route path='/about' element={<About/>}></Route>
    <Route path='/school' element={<SchoolERP/>}></Route>
    <Route path='/habitech' element={<HabiTech/>}></Route>
    <Route path='/contact' element={<Contact/>}></Route>
    <Route path='/bookademo' element={<BookADemo/>}></Route>
    <Route path='/careerpage' element={<Career/>}></Route>

    
    </Routes>    
    <Footer /> 
    </Router> 
     
  )
}

export default App